import { Controller } from '@hotwired/stimulus'

// Generic controller to show/hide a target element based on an input's value.
//
// Usage:
//   <div data-controller="toggle-visibility"
//        data-toggle-visibility-show-value="custom">
//     <input type="radio" name="preset" value="custom"
//            data-action="toggle-visibility#toggle"
//            data-toggle-visibility-target="input">
//     <div data-toggle-visibility-target="content">
//       <!-- shown only when the input value matches -->
//     </div>
//   </div>
//
// A <select> target works too: its chosen value is compared.
export default class extends Controller {
  static targets = ['input', 'content']
  static values = { show: String }

  connect() {
    this.toggle()
  }

  toggle() {
    const chosen = this.inputTargets.find((el) => el.tagName === 'SELECT' || el.checked)
    const match = chosen && chosen.value === this.showValue
    this.contentTargets.forEach((el) => el.classList.toggle('d-none', !match))
  }
}
